export default {
  init() {
    initMap();
    
    $('.filter-all').on('click', function(e) {
      e.preventDefault();
      $(".filter-all").toggleClass('filtered');
    });

    $('.clear-search').on('click', function() {
      $('.filter-all').removeClass('filtered');
      $('.checkbox-dropdown button').removeClass('active');
      $('.checkbox-dropdown button').removeClass('filtered');
      $('#search-query').val('');
      $('input[type="checkbox"]').attr('checked', false);
    });

    $('.checkbox-dropdown button').on('click', function(e) {
      e.preventDefault();
      const active = $(this).hasClass('active');
      $('.checkbox-dropdown button').removeClass('active');
      if (active) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });
    
    $(document).bind('click', function(e) {
      var $clicked = $(e.target);
      if (!$clicked.parents().hasClass("dropdown")) $(".dropdown dd ul").hide();
    });
    
    $('.checkbox-dropdown fieldset').on('mouseout', function(event) {
      var e = event.toElement || event.relatedTarget;
      if (e.parentNode == this || e == this || e.parentNode.parentNode == this) {
          return;
      }
      $('.checkbox-dropdown button').removeClass('active');
    });
    
    $( "#filter-lease" ).click(function() {
      $( "#filter-purchase" ).removeClass('active');
      $(this).addClass('active');
    });

    $( "#filter-purchase" ).click(function() {
      $( "#filter-lease" ).removeClass('active');
      $(this).addClass('active');
    });
    
    $('input[type="checkbox"]').change(function() {
      setFilteredClass();
    });
    
    function setFilteredClass() {
      if($(".filter-type:checked").length > 0) {
        $(".filter-type button").addClass('filtered');
      } else {
        $(".filter-type button").removeClass('filtered');
      }

      if($(".filter-city:checked").length > 0) {
        $(".filter-city button").addClass('filtered');
      } else {
        $(".filter-city button").removeClass('filtered');
      }

      if($(".filter-size:checked").length > 0) {
        $(".filter-size button").addClass('filtered');
      } else {
        $(".filter-size button").removeClass('filtered');
      }

      if($(".filter-broker:checked").length > 0) {
        $(".filter-broker button").addClass('filtered');
      } else {
        $(".filter-broker button").removeClass('filtered');
      }
    }

     /* eslint-disable */
    function propertySearch() {
      let filter = $('#filter-purchase').hasClass('active') ? 'purchase' : 'lease',
          type = "",
          city = "",
          size = "",
          broker = "",
          query = $('#search-query').val(),
          all = $('#filter-all').hasClass('active') ? true : false;
      
      console.log(filter);
      
      $("input[type=checkbox][name=filter]:checked").map(function(e, i) {
        filter = (filter !== '') ? filter + ',' + $(i).val() : $(i).val();
      });
      $("input[type=checkbox][name=type]:checked").map(function(e, i) {
        type = (type !== '') ? type + ',' + $(i).val().toLowerCase() : $(i).val().toLowerCase();
      });
      $("input[type=checkbox][name=city]:checked").map(function(e, i) {
        city = (city !== '') ? city + ',' + $(i).val() : $(i).val();
      });
      $("input[type=checkbox][name=size]:checked").map(function(e, i) {
        size = (size !== '') ? size + ',' + $(i).val() : $(i).val();
      });
      $("input[type=checkbox][name=broker]:checked").map(function(e, i) {
        broker = (broker !== '') ? broker + ',' + $(i).val() : $(i).val();
      });
      
      let propertyFilterUrl = '/properties/?filter=' + filter + '&type=' + type + '&city=' + city + '&size=' + size + '&broker=' + broker + '&query=' + query + ((all) ? '&filter-all=true' : '');
      
      window.location.href = propertyFilterUrl;
    }
     /* eslint-enable */

     $('#search-submit').click(function(e) {
       e.preventDefault();
       propertySearch();
     });

    function initMap() {

    window.map = new window.google.maps.Map(document.getElementById('property-map'), {
      center: {lat: 47.6901, lng: -122.2905},
      zoom: 14,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_TOP,
      },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,

      styles: [
        {"elementType": "geometry", "stylers": [{"color": "#1d2c4d"}] },
        {"elementType": "labels.text.fill","stylers": [{"color": "#8ec3b9"}]},
        {"elementType": "labels.text.stroke","stylers": [{"color": "#1a3646"}]},
        {"featureType": "administrative","elementType": "geometry","stylers": [{"visibility": "off"}]},
        {"featureType": "administrative.country","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
        {"featureType": "administrative.land_parcel","elementType": "labels.text.fill","stylers": [{"color": "#64779e"}]},
        {"featureType": "administrative.province","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
        {"featureType": "landscape","elementType": "geometry.fill","stylers": [{"color": "#3e5962"}]},
        {"featureType": "poi","stylers": [{"visibility": "off"}]},
        {"featureType": "poi","elementType": "geometry","stylers": [{"color": "#283d6a"}]},
        {"featureType": "poi","elementType": "labels.text.fill","stylers": [{"color": "#6f9ba5"}]},
        {"featureType": "poi","elementType": "labels.text.stroke","stylers": [{"color": "#1d2c4d"}]},
        {"featureType": "road", "elementType": "geometry","stylers": [{"color": "#304a7d"}]},
        {"featureType": "road","elementType": "geometry.fill","stylers": [{"color": "#138c83"},{"weight": 5}]},
        {"featureType": "road","elementType": "geometry.stroke","stylers": [{"visibility": "off"}]},
        {"featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] },
        {"featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#7eada7" } ] },
        {"featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1f3f4a" } ] },
        {"featureType": "road.arterial", "stylers": [ { "visibility": "off" } ] },
        {"featureType": "road.highway", "elementType": "labels", "stylers": [ { "visibility": "off" } ] },
        {"featureType": "road.local", "stylers": [ { "visibility": "off" } ] },
        {"featureType": "transit", "stylers": [ { "visibility": "off" } ] },
        {"featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "color": "#98a5be" } ] },
        {"featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1d2c4d" } ] },
        {"featureType": "transit.line", "elementType": "geometry.fill", "stylers": [ { "color": "#283d6a" } ] },
        {"featureType": "transit.station", "elementType": "geometry", "stylers": [ { "color": "#3a4762" } ] },
        {"featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#1f3f4a" } ] },
        {"featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#4e6d70" } ] },
      ],
    });

    window.properties.forEach(function(property) {
      var marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(property.lat, property.long),
        icon: '../../map-icon-hover.png',
        id: property.id,
        map: window.map,
      });
      window.map.panTo(new window.google.maps.LatLng(property.lat, property.long));
      console.log(marker);
    });

  }
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
